import Vue from 'vue'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store/index.js'
Vue.use(VueAxios, Axios)

// Set the X-CERF-TOKEN for our forms
Axios.defaults.headers.common['X-CSRF-TOKEN'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')

// Import and use the scrollto...
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: 'ease',
  offset: -80,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

// ROUTER:
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// ROOTS
import BaseHome from '../../shared/pages/BaseHome.vue'
import BasePosts from '../../shared/tenant/BasePosts.vue'
import BasePost from '../../shared/tenant/BasePost.vue'
import BaseSettings from '../../shared/tenant/BaseSettings.vue'
import BaseManagePages from '../../shared/tenant/BaseManagePages.vue'
import BaseMediaItems from '../../shared/tenant/BaseMediaItems.vue'
import BaseMediaItem from '../../shared/tenant/BaseMediaItem.vue'
import BasePageEdit from '../../expo/tenant/manager/BasePageEdit.vue'
import PublicNewsletter from '../../careerwise/tenant/public/pages/Newsletter.vue'
// Manager
import PageHailMail from '../../careerwise/tenant/manager/pages/mail/PageHailmail.vue'
import PageConnections from '../../careerwise/shared/connections/PageConnections.vue'
import PublicConnections from '../../careerwise/shared/connections/PublicConnections.vue'
import PageAutomations from '../../careerwise/tenant/manager/pages/Automations.vue'
// import Tenant1PostNew from '../route/manager/auth/Tenant1PostNew.vue'
import CWDrafts from '../../careerwise/tenant/manager/pages/Drafts.vue'
import CWCloudHome from '../../careerwise/tenant/manager/pages/cloud/PageCloud.vue'
import CWAnalytics from '../../careerwise/tenant/manager/pages/Analytics.vue'
import CWHootmail from '../../careerwise/tenant/manager/pages/Hootmail.vue'
import CWTenantLibrary from '../../careerwise/tenant/manager/pages/library/PageLibrary.vue'
//CW Marketing
import CWForSchools from '../../careerwise/central/pages/ForSchools.vue'
// import CWPricing from '../../careerwise/central/pages/Pricing.vue'
import CWForBusinesses from '../../careerwise/central/pages/ForBusinesses.vue'
// import BenefitsSchools from '../../careerwise/central/pages/BenefitsSchools.vue'
// import BenefitsBusinesses from '../../careerwise/central/pages/BenefitsBusinesses.vue'
import CWConnections from '../../careerwise/central/pages/Connections.vue'
// Contributor Dashboard -- CD Contributor Dashboard
import CDHome from '../../careerwise/contributor/pages/Home.vue'
import CDPosts from '../../careerwise/contributor/pages/Posts.vue'
import CDStats from '../../careerwise/contributor/pages/Statistics.vue'
import CDSettings from '../../careerwise/contributor/pages/Settings.vue'
import CDAccounts from '../../careerwise/contributor/pages/Accounts.vue'
import CDConnections from '../../careerwise/contributor/pages/Connections.vue'
// Contributor Profile
import CDProfile from '../../careerwise/contributor/profile/Home.vue'
//Expo
import ExpoStatistics from '../../expo/tenant/manager/Statistics.vue'
import ExpoCentralForSchools from '../../expo/central/pages/ForSchools.vue'
import ExpoRegistrationSchools from '../../expo/central/pages/RegistrationSchools.vue'
import ExpoCentralForExhibitors from '../../expo/central/pages/ForExhibitors.vue'
import ExpoRegistrationExhibitor from '../../expo/central/pages/RegistrationExhibitor.vue'
import ExpoCentralWorldOfWork from '../../expo/central/pages/WorldOfWork.vue'
import ExpoCentralContact from '../../expo/central/pages/Contact.vue'
// Expo Cloud
import ExpoOnlinePosts from '../../expo/online/pages/Posts.vue'
// Test sandbox
import ExpoCentralEvent from '../../expo/central/pages/Event.vue'
/**
 * CLOUD TEMPLATE ROUTES:
 */
import CWCloudPosts from '../../careerwise/cloud/pages/Posts.vue'
import CWCloudPost from '../../careerwise/cloud/pages/Post.vue'
import CWAuthorProfile from '../../careerwise/cloud/pages/AuthorProfile.vue'
// A combo template top deal with expo report model and exhibitor cloud post model
import ExpoCentralOnlinePost from '../../expo/Post.vue'

/**
 *
 * USE middlewareAuthAdmin to check if user is authenticated and is an admin...
 */

const routes = [
  {
    path: '/event/:slug',
    alias: 'event',
    name: 'Event',
    component: ExpoCentralEvent,
    props: (route) => {
      let slug = route.params.slug

      slug = slug.replace(/^\s+|\s+$/g, '') // trim
      slug = slug.toLowerCase()

      // remove accents, swap ñ for n, etc
      let from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      let to = 'aaaaeeeeiiiioooouuuunc------'
      for (let i = 0, l = from.length; i < l; i++) {
        slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      slug = slug
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashe

      return { slug }
    },
  },

  /**
   * CLOUD TEMPLATE ROUTES:
   */

  {
    path: '/cloudposts',
    alias: 'cloudposts',
    name: 'Cloudposts',
    component: CWCloudPosts,
  },

  {
    path: '/cloudpost/:post_id',
    alias: 'cloudpost',
    name: 'Cloudpost',
    component: CWCloudPost,
    props: (route) => {
      const post_id = Number.parseInt(route.params.post_id)
      return { post_id }
    },
  },

  /* CW Cloud Directory profile pages : This uses the organisation model for contributor profiles and the tenant model for school profiles ... */

  {
    path: '/organisation/:author_id',
    alias: 'organisation_directory',
    name: 'OrganisationDirectory',
    component: CWAuthorProfile,
    props: (route) => {
      const author_id = Number.parseInt(route.params.author_id)
      return { author_id }
    },
  },

  {
    path: '/school/:author_id',
    alias: 'school_directory',
    name: 'SchoolDirectory',
    component: CWAuthorProfile,
    props: (route) => {
      const tenant = true
      const author_id = Number.parseInt(route.params.author_id)
      return { author_id, tenant }
    },
  },

  {
    path: '/contributor/:author_id',
    alias: 'contributor_directory',
    name: 'ContributorDirectory',
    component: CWAuthorProfile,
    props: (route) => {
      const tenant = true
      const author_id = Number.parseInt(route.params.author_id)
      return { author_id, tenant }
    },
  },

  // {
  //     path: '/signin',
  //     alias : 'signin',
  //     name : 'Signin',
  //     component: ValidateLogin,
  //     meta: { loginexpired: false }
  // },

  {
    path: '/',
    alias: 'homepage',
    name: 'Home',
    component: BaseHome,
  },
  // {
  //   path: '/pricing',
  //   alias: 'pricing',
  //   name: 'Pricing',
  //   component: CWPricing,
  //   meta: {
  //     analyticsIgnore: true,
  //   },
  // },
  // {
  //   path: '/benefits-schools',
  //   alias: 'benefits-schools',
  //   name: 'BenefitsSchools',
  //   component: BenefitsSchools,
  //   meta: {
  //     analyticsIgnore: true,
  //   },
  // },
  // {
  //   path: '/benefits-businesses',
  //   alias: 'benefits-businesses',
  //   name: 'BenefitsBusinesses',
  //   component: BenefitsBusinesses,
  //   meta: {
  //     analyticsIgnore: true,
  //   },
  // },
  {
    path: '/cw-for-schools',
    alias: 'cwforschools',
    name: 'CWForSchools',
    component: CWForSchools,
    meta: {
      analyticsIgnore: true,
    },
  },
  {
    path: '/cw-for-businesses',
    alias: 'cwforbusinesses',
    name: 'CWForBusinesses',
    component: CWForBusinesses,
    meta: {
      analyticsIgnore: true,
    },
  },
  {
    path: '/connections-feature',
    alias: 'connections-feature',
    name: 'CWConnections',
    component: CWConnections,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/cloud/dashboard',
    alias: 'contributorsDashboard',
    name: 'ContributorsDashboard',
    component: CDHome,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      actions: ['contributors/dispatchInitPageDashboard'],
    },
  },

  {
    path: '/cloud/posts',
    alias: 'contributorsPosts',
    name: 'ContributorsPosts',
    component: CDPosts,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
    },
  },

  {
    path: '/cloud/drafts',
    alias: 'contributorsDrafts',
    name: 'ContributorsDrafts',
    component: CDPosts,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
    },
  },

  {
    path: '/cloud/post/:post_id',
    alias: 'contributorsPost',
    name: 'ContributorsPost',
    component: BasePost,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
    },
    props: (route) => {
      const post_id = Number.parseInt(route.params.post_id)
      const edit = route.params.edit
      return { post_id, edit }
    },
  },

  {
    path: '/cloud/connections',
    alias: 'contributorsConnections',
    name: 'ContributorsConnections',
    component: CDConnections,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      isConnectionsOnlyAdminRoute: true,
      actions: ['contributors/dispatchInitPageConnections'],
    },
  },

  {
    path: '/cloud/add-connection',
    alias: 'contributorsAddConnection',
    name: 'ContributorsAddConnection',
    component: CDConnections,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      isConnectionsOnlyAdminRoute: true,
    },
  },

  {
    path: '/cloud/update-connection',
    alias: 'contributorsUpdateConnection',
    name: 'ContributorsUpdateConnection',
    component: CDConnections,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      isConnectionsOnlyAdminRoute: true,
    },
  },

  {
    path: '/cloud/settings',
    alias: 'contributorsSettings',
    name: 'ContributorsSettings',
    component: CDSettings,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      actions: ['contributors/dispatchInitPageSettings'],
    },
  },

  {
    path: '/cloud/accounts',
    alias: 'contributorsAccounts',
    name: 'ContributorsAccounts',
    component: CDAccounts,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
      // actions: ['contributors/dispatchUpdateAccounts'],
    },
  },

  {
    path: '/cloud/statistics',
    alias: 'contributorsStatistics',
    name: 'ContributorsStatistics',
    component: CDStats,
    meta: {
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
      isPortal: true,
    },
  },

  {
    path: '/cloud/:orgSlug',
    alias: 'contributorsProfile',
    name: 'ContributorsProfile',
    component: CDProfile,
    meta: {
      analyticsIgnore: true,
      isPortal: false,
    },
    beforeEnter: async (to, from, next) => {
      const slug = to.params.orgSlug
      const valid = await store.dispatch(
        'contributors/dispatchVerifyPublicProfile',
        {
          slug,
        },
      )

      if (valid) {
        // Contributor has a valid public profile - proceed to the route
        await Promise.all([
          store.dispatch('contributors/dispatchUpdateProfilePosts'),
          store.dispatch('contributors/dispatchUpdateProfileConnections'),
        ])

        next()
      } else {
        // Contributor invalid or does not have public profile - redirect to home
        next({ name: 'Home' })
      }
    },
  },

  {
    path: '/posts',
    alias: 'posts',
    name: 'Posts',
    component: BasePosts,
    props: (route) => {
      const draft = route.params.draft
      return { draft }
    },
  },

  {
    path: '/post/:post_id',
    alias: 'post',
    name: 'Post',
    component: BasePost,
    props: (route) => {
      const post_id = Number.parseInt(route.params.post_id)
      const edit = route.params.edit
      return { post_id, edit }
    },
  },

  {
    path: '/page/:page_id',
    alias: 'page',
    name: 'Page',
    component: BasePost,
    props: (route) => {
      const post_id = Number.parseInt(route.params.page_id)
      const page = true
      return { post_id, page }
    },
  },

  {
    path: '/newsletter/:newsletterId',
    alias: 'publicNewsletter',
    name: 'PublicNewsletter',
    component: PublicNewsletter,
    props: (route) => {
      const newsletterId = Number.parseInt(route.params.newsletterId)
      return { newsletterId }
    },
  },

  // @TODO public-facing Connections views
  // {
  //   path: '/connections',
  //   name: 'Connections',
  //   component: PageConnections,
  //   meta: { analyticsIgnore: true },
  // },

  // public- and admin-facing "Add Connection" form
  {
    path: '/add-connection',
    name: 'AddConnection',
    component: PageConnections,
    meta: { context: 'connections' },
  },

  {
    path: '/connections',
    name: 'PublicConnections',
    component: PublicConnections,
    meta: {
      context: 'connections',
    },
  },

  // public- and admin-facing "Update Connection" form
  // {
  //   path: '/update-connection',
  //   name: 'UpdateConnection',
  //   component: PageConnections,
  //   meta: { analyticsIgnore: true },
  // },

  // Administrator access routes

  {
    path: '/manager/settings',
    alias: 'settings',
    name: 'Settings',
    component: BaseSettings,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/mail',
    alias: 'mail',
    name: 'Mail',
    component: PageHailMail,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  // Admin-facing Connections views
  {
    path: '/manager/connections',
    name: 'ManagerConnections',
    component: PageConnections,
    meta: {
      context: 'connections',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/add-connection',
    name: 'ManagerAddConnection',
    component: PageConnections,
    meta: {
      context: 'connections',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/update-connection',
    name: 'ManagerUpdateConnection',
    component: PageConnections,
    meta: {
      context: 'connections',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  //  Reports
  {
    path: '/manager/reports',
    name: 'ManagerReports',
    component: PageConnections,
    meta: {
      context: 'reports',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/update-report',
    name: 'ManagerUpdateReport',
    component: PageConnections,
    meta: {
      context: 'reports',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/add-report',
    name: 'ManagerAddReport',
    component: PageConnections,
    meta: {
      context: 'reports',
      middlewareAuthAdmin: true,
      analyticsIgnore: true,
    }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/drafts',
    alias: 'drafts',
    name: 'Drafts',
    component: CWDrafts,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/pages',
    alias: 'pages',
    name: 'Pages',
    component: BaseManagePages,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/page/:post_id',
    alias: 'editPage',
    name: 'editPage',
    component: BasePageEdit,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
    props: (route) => {
      const post_id = Number.parseInt(route.params.post_id)
      const page = true
      return { post_id, page }
    },
  },

  {
    path: '/manager/pages/:post_id',
    alias: 'editTenant1Page',
    name: 'editTenant1Page',
    component: BasePost,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
    props: (route) => {
      const post_id = Number.parseInt(route.params.post_id)
      const edit = true
      const page = true
      return { post_id, edit, page }
    },
  },

  {
    path: '/manager/cloud',
    alias: 'cloud',
    name: 'Cloud',
    component: CWCloudHome,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/resources',
    alias: 'resources',
    name: 'Resources',
    component: BaseMediaItems,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/resource/:resource_id',
    alias: 'resource',
    name: 'Resource',
    component: BaseMediaItem,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
    props: (route) => {
      const resource_id = Number.parseInt(route.params.resource_id)
      return { resource_id }
    },
  },

  {
    path: '/manager/library',
    alias: 'library',
    name: 'Library',
    component: CWTenantLibrary,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/analytics',
    alias: 'analytics',
    name: 'Analytics',
    component: CWAnalytics,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/hootmail',
    alias: 'hootmail',
    name: 'Hootmail',
    component: CWHootmail,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  {
    path: '/manager/automations',
    alias: 'automations',
    name: 'Automations',
    component: PageAutomations,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },

  // EXPO

  {
    path: '/exhibitor-latest-news',
    alias: 'exhibitor-latest-news',
    name: 'ExhibitorLatestNews',
    component: ExpoOnlinePosts,
  },

  // Same ExpoCentralOnlinePost but different URL's
  {
    path: '/news/:news_id',
    alias: 'news',
    name: 'News',
    component: ExpoCentralOnlinePost,
    props: (route) => {
      const news_id = Number.parseInt(route.params.news_id)
      return { news_id }
    },
  },
  {
    path: '/resource/:resource_id',
    alias: 'resources',
    name: 'Resources',
    component: ExpoCentralOnlinePost,
    props: (route) => {
      const resource_id = Number.parseInt(route.params.resource_id)
      return { resource_id }
    },
  },
  // Same ExpoCentralOnlinePost but different URL's

  // {
  //     path: '/exhibitors',
  //     alias : 'exhibitors',
  //     name : 'Exhibitors',
  //     component: Exhibitors,
  //     meta: {
  //         analyticsIgnore: true
  //     }
  // },

  {
    path: '/for-schools',
    alias: 'schools',
    name: 'Schools',
    component: ExpoCentralForSchools,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/school-registration',
    alias: 'schoolregistration',
    name: 'SchoolRegistration',
    component: ExpoRegistrationSchools,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/for-exhibitors',
    alias: 'forexhibitors',
    name: 'ForExhibitors',
    component: ExpoCentralForExhibitors,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/exhibitor-registration',
    alias: 'exhibitorregistration',
    name: 'ExhibitorRegistration',
    component: ExpoRegistrationExhibitor,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/world-of-work',
    alias: 'worldofwork',
    name: 'worldofwork',
    component: ExpoCentralWorldOfWork,
    meta: {
      analyticsIgnore: true,
    },
  },

  {
    path: '/contact-us',
    alias: 'contact',
    name: 'contact',
    component: ExpoCentralContact,
    meta: {
      analyticsIgnore: true,
    },
  },

  // expo manager
  {
    path: '/manager/statistics',
    alias: 'statistics',
    name: 'Statistics',
    component: ExpoStatistics,
    meta: { middlewareAuthAdmin: true, analyticsIgnore: true }, // Only users who are administrators can access this!
  },
]

export default new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      VueScrollTo.scrollTo('body', 700)
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
